import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { createEntitiesSelector } from '../../../../entity/entities.reducer';
import { EntityTypes } from '../../../../entity/entity-types';
import { EntityState } from '../../../../entity/entity.reducer';
import { Entities } from '../../../../entity/entities';
import { createSymfonyTotalCountSelector } from '../../../../symfony/list/selectors/list.selectors';
import { getServiceProjectOperationListState } from '../operation.reducer';
import { ServiceProjectOperation } from '../models/operation';

const createState = (id: IdType) => createSelector(
  getServiceProjectOperationListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateById = (id: IdType) => createListStateIdsSelector(createState(id));

export const createServiceProjectOperationListData = (id: IdType) => createSelector(
  createStateById(id),
  createEntitiesSelector([
    EntityTypes.projectOperation
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.projectOperation]], entities) as ServiceProjectOperation[]
);

export const createServiceProjectOperationListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createServiceProjectOperationListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createServiceProjectOperationListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createServiceProjectOperationListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createServiceProjectOperationListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
